import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { take } from 'rxjs/operators';
import 'rxjs/add/operator/toPromise';
import * as firebase from 'firebase/app';
import { UserModel } from './user.model';
import { AngularFireStorage } from 'angularfire2/storage';

@Injectable()
export class UserProvider {
  collection: any;
  private user: any;

  constructor(
    private afs: AngularFirestore,
    public storage: AngularFireStorage
  ) {
  }
  
  checkUserAccount(user) {
    return new Promise<any>((resolve, reject) => {
      // console.log("checkUserAccount",user);
      let result = false;
      this.afs.collection('users', ref => 
      ref.where('uid', '==', user.uid)
      )
      .valueChanges()
      .pipe(take(1))
      .subscribe(data => {
        // console.log("data",data);
        if(data.length > 0){
          result = true;
          this.updateColumnUser(data[0]);
        }
        this.setUser(data[0]);
        resolve(result);
      });
    });
  }

  async updateColumnUser(user){
    if(this.collection== null)
      this.collection = this.afs.collection("users");
    let update_required = false;
    // console.log("user.created_datetime",user)
    if(user.created_datetime == null){
      user.created_datetime = new Date();
      update_required = true;
    }
    if(user.count_events_created == null){
      user.count_events_created = 0;
      update_required = true;
    }
    if(user.count_events_participate == null){
      user.count_events_participate = 0;
      update_required = true;
    }
    if(user.bio == null){
      console.log('add user bio');
      user.bio = "";
      update_required = true;
    }
    if(user.link == null){
      user.link = "";
      update_required = true;
    }
    if(update_required){
      console.log("updateUser required");
      await this.collection.doc(user.uid).set(user);
    }
  }
  
  async updateUserPicture(id, picture){
    // console.log("updateUserPicture",picture);
    if(this.isDataURL(picture)){
      await this.storage.ref('users/' + id).putString(picture, 'data_url');
    }
    else{
      console.error("not base 64");
    }
  }
  
  isDataURL(s) {
    let regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
    return !!s.match(regex);
  }
  async updateUser(user){
    await this.collection.doc(user.uid).set(user)
    .then((data) => {
      console.log("updateUser finish", data);
      return true;
    })
    .catch((error) => {
      console.error("Error saving post : ", error);
      return false;
    })
  }

  setUser(user){
    this.user = user;
  }

  getUser(user_id = null){
    // console.log("UserProvider getUser",user_id);
    return new Promise<any>((resolve, reject) => {
      if(user_id == null){
        if(this.user != null)
          user_id = this.user.uid
        else
          resolve(null);
      }
      
      this.afs.collection('users', ref => 
      ref.where('uid', '==', user_id)
      )
      .valueChanges()
      .pipe(take(1))
      .subscribe(data => {
        // console.log("UserProvider getUser result",data);
        resolve(data[0]);
      });
    });
  }

  async createUser(){
    if(this.collection== null)
      this.collection = await this.afs.collection("users");
    console.log("createUser");
    let userData = await this.getCurrentUser();
    this.setUser(userData);
    this.collection.doc(userData.uid).set(userData.getData());
  }

  getCurrentUser(){
    return new Promise<any>((resolve, reject) => {
      firebase.auth().onAuthStateChanged(function(user){
        let userModel = new UserModel();
        if (user) {
          if(user.providerData[0].providerId == 'password'){
            //use a default image
            userModel.image = "../assets/imgs/default_avatar.png";
          }
          else{
            userModel.image = user.photoURL;
          }
          userModel.uid = user.uid;
          userModel.name = user.displayName;
          userModel.provider = user.providerData[0].providerId;
          return resolve(userModel);
        } else {
          reject('No user logged in');
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/user/user.provider.ts